module.exports = __webpack_public_path__ + "b8f309b357d623122ae4fc7795669256.svg";